import React, { Component } from 'react';
import styled from 'styled-components';
import Lightbox from 'react-images';
import media from 'src/styles/media';

import data from 'src/data/interior';
import Header from 'src/components/Header';
import TabContent from 'src/components/TabContent/TabContent';
import ContentBlock from 'src/components/ContentBlock';
import ScrollAnimation from 'src/components/ScrollAnimation';
import DarkCircle from 'src/components/DarkCircle';
import NextLine from 'src/components/NextLine';
import RegisterButton from 'src/components/RegisterButton';
import imgLiving from 'src/assets/images/interiors/living.jpg';
import imgLivingFull from 'src/assets/images/interiors/livingroom-full.jpg';
import imgKitchen from 'src/assets/images/interiors/kitchen.jpg';
import imgKitchenFull from 'src/assets/images/interiors/kitchen-full.jpg';
import imgBedroom from 'src/assets/images/interiors/bedroom.jpg';
import imgBedroomFull from 'src/assets/images/interiors/bedroom-full.jpg';
import imgEnsuite from 'src/assets/images/interiors/ensuite.jpg';
import imgEnsuiteFull from 'src/assets/images/interiors/ensuite-full.jpg';
import imgBackgroundCircle from 'src/assets/images/background-circle.svg';

const images = [imgLiving, imgKitchen, imgBedroom, imgEnsuite];
const lightboxImages = [
  {
    src: imgLivingFull,
  },
  {
    src: imgKitchenFull,
  },
  {
    src: imgBedroomFull,
  },
  {
    src: imgEnsuiteFull,
  },
];

const imageData = [
  {
    text: (
      <div>
        <h3>Living Room</h3>
        <p>Spacious living areas</p>
        <p>Contemporary finishes</p>
      </div>
    ),
  },
  {
    text: (
      <div>
        <h3>Kitchen</h3>
        <p>Kitchen Under-cabinet Lighting</p>
        <p>Polished Quartz Countertops</p>
        <p>Porcelain Backsplash</p>
      </div>
    ),
  },
  {
    text: (
      <div>
        <h3>Bedroom</h3>
        <p>Large, expressive windows maximizing natural light</p>
      </div>
    ),
  },
  {
    text: (
      <div>
        <h3>Ensuite</h3>
        <p>Kohler Fixtures</p>
        <p>Porcelain Tiles</p>
        <p>Polished Caesarstone Countertops</p>
      </div>
    ),
  },
];

class Interiors extends Component {
  state = {
    lightboxIsOpen: false,
    currentImage: 0,
  };

  handleLightBox = index =>
    this.setState({
      lightboxIsOpen: !this.state.lightboxIsOpen,
      currentImage: index,
    });

  closeLightBox = () => this.setState({ lightboxIsOpen: false });

  gotoNext = () => this.setState({ currentImage: this.state.currentImage + 1 });

  gotoPrevious = () =>
    this.setState({ currentImage: this.state.currentImage - 1 });

  render() {
    return (
      <Root>
        <Header
          image={imgLiving}
          smallText={'Interiors'}
          largeText={'Classic Design'}
          darken
        />
        <Lightbox
          images={lightboxImages}
          currentImage={this.state.currentImage}
          isOpen={this.state.lightboxIsOpen}
          onClickPrev={this.gotoPrevious}
          onClickNext={this.gotoNext}
          onClose={this.closeLightBox}
          backdropClosesModal
          enableKeyboardInput
        />
        <ScrollAnimation>
          <Text>
            The homes at 618 Carnarvon are designed for{' '}
            <span>modern urban living</span>. Inspired by single-family homes,
            entrances lead into <span>open living spaces</span> for family
            activities with adjoining bedrooms providing privacy when preferred.
            This classic design offers practicality and{' '}
            <span>incredible views</span> from both the bedroom and living
            areas.
          </Text>
          {images.map((image, index) => (
            <Image image={image} last={index === images.length - 1} key={index}>
              <StyledDarkCircle
                text={imageData[index].text}
                top={'70%'}
                left={index % 2 === 0 ? '20%' : '80%'}
              />
              <FullImage
                onClick={() => this.handleLightBox(index)}
                left={index % 2 === 0 ? '80%' : '20%'}
              >
                See Full Image
              </FullImage>
              {index % 2 === 0 && (
                <BackgroundCircle
                  src={imgBackgroundCircle}
                  top={'100%'}
                  left={index === 2 ? '50%' : '90%'}
                />
              )}
            </Image>
          ))}
          <Desktop>
            <StyledContentBlock
              title="Elevated Luxuries"
              body="The perfect balance of everyday convenience and contemporary elegance, the features of 618 Carnarvon have been thoughtfully crafted to intergrate beauty and functionality into every detail of your dream home. Whether it is the subtle design cues of the interior décor, the chic ensuites enhancing each home, or the abundant amenities throughout the building, every aspect has been considered to provide an elevated living experience."
            />
            <StyledLink
              href={'assets/images/featuresheet.pdf'}
              target="_blank"
              desktop
            >
              Download Feature Sheet
            </StyledLink>
          </Desktop>
          <StyledTabContent tabData={data} />
          <StyledLink href={'assets/images/featuresheet.pdf'} target="_blank">
            Download Feature Sheet
          </StyledLink>
          <NextLine text={'Next: Floorplans'} link={'/floorplans'} />
          <RegisterButton />
        </ScrollAnimation>
      </Root>
    );
  }
}

export default Interiors;

const Root = styled.div`
  overflow: hidden;
`;

const StyledContentBlock = styled(ContentBlock)`
  width: 90%;
  margin: 0 auto;
  text-align: center;
  @media (min-width: ${media.smup}) {
    width: 475px;
  }
  @media (min-width: ${media.mdup}) {
    text-align: left;
    width: 587px;
    margin: 0;
    max-width: none;
    padding-left: 0;
    padding-right: 0;
    h1 {
      margin-left: 0;
      margin-right: 0;
      max-width: none;
      text-align: left;
    }
    p {
      max-width: 587px;
    }
  }
`;

const Text = styled.p`
  width: 80%;
  margin: 105px auto 80px;
  font-family: ${({ theme }) => theme.fontMain};
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  opacity: 0.72;
  @media (min-width: ${media.smup}) {
    width: 475px;
  }
  span {
    color: ${({ theme }) => theme.colorPrimary};
  }
`;

const Image = styled.div`
  background-image: url(${props => props.image});
  background-position: center;
  background-size: cover;
  position: relative;
  width: 100%;
  height: 100vw;
  border-top: 10px solid ${({ theme }) => theme.colorDarkBlue};
  border-bottom: 10px solid ${({ theme }) => theme.colorDarkBlue};
  margin-top: 200px;
  @media (min-width: ${media.smup}) {
    border-top: 0;
    border-bottom: ${props =>
      props.last ? '0' : `36px solid ${props.theme.colorDarkBlue}`};
    margin-top: 0;
    height: 60vw;
  }
`;

const StyledDarkCircle = styled(DarkCircle)`
  position: absolute;
  transform: translate(-50%, -50%);
  top: 0;
  left: 50%;
  z-index: 100;
  @media (min-width: ${media.smup}) {
    top: ${props => props.top};
    left: ${props => props.left};
  }
`;

const StyledLink = styled.a`
  height: 35px;
  width: 200px;
  margin: 0 auto 50px;
  display: ${props => (props.desktop ? 'none' : 'flex')};
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 17.5px;
  background-color: white;
  font-family: ${({ theme }) => theme.fontHeader};
  font-size: 12px;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.83);
  transition: 0.3s ease;
  cursor: pointer;
  @media (min-width: ${media.smup}) {
    margin: ${props => (props.desktop ? '147px 0 50px 100px' : '0 auto 50px')};
  }
  @media (min-width: ${media.mdup}) {
    display: ${props => (props.desktop ? 'flex' : 'none')};
    margin: ${props => (props.desktop ? '147px 0 50px 100px' : '0 auto 50px')};
  }
  @media (min-width: 1200px) {
    display: ${props => (props.desktop ? 'flex' : 'none')};
    margin: ${props => (props.desktop ? '147px 0 50px 170px' : '0 auto 50px')};
  }
  &:hover {
    background-color: ${({ theme }) => theme.colorPrimary};
  }
`;

const Desktop = styled.div`
  @media (min-width: ${media.mdup}) {
    display: flex;
    width: 75%;
    margin: 0 auto;
  }
  @media (min-width: ${media.xlup}) {
    width: 75%;
  }
`;

const FullImage = styled.button`
  background-color: white;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 17.5px;
  text-transform: uppercase;
  height: 35px;
  width: 143px;
  font-size: 12px;
  font-family: ${({ theme }) => theme.fontHeader};
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  color: black;
  transition: 0.3s ease;
  cursor: pointer;
  z-index: 100;
  &:hover {
    background-color: ${({ theme }) => theme.colorPrimary};
  }
  @media (min-width: ${media.smup}) {
    left: ${props => props.left};
    bottom: 12%;
  }
`;

const StyledTabContent = styled(TabContent)`
  width: 90%;
  margin-bottom: 50px;
  margin-top: 0;
  @media (min-width: ${media.mdup}) {
    width: 75%;
    justify-content: flex-start;
  }
  @media (min-width: ${media.xlup}) {
    width: 75%;
  }
  & > div:first-child {
    @media (min-width: ${media.smup}) {
      width: 40%;
    }
    @media (min-width: ${media.mdup}) {
      margin-right: 88px;
    }
  }
  & > div:nth-child(2) {
    justify-self: center;
    @media (min-width: ${media.smup}) {
      justify-self: flex-start;
      width: 60%;
    }
    @media (min-width: ${media.mdup}) {
      width: 60%;
    }
    ul {
      display: flex;
      flex-flow: wrap column;
      justify-content: space-between;
      max-height: 500px;
      @media (min-width: ${media.smup}) {
        margin-top: 0;
      }
      @media (min-width: ${media.lgup}) {
        max-height: 390px;
        &.larger-list li {
          max-width: 560px;
        }
      }
      li {
        list-style-type: none;
        margin-bottom: 15px;
        align-self: center;
        @media (min-width: ${media.smup}) {
          width: 45%;
        }
        @media (min-width: ${media.mdup}) {
          width: auto;
          max-width: 320px;
          align-self: flex-start;
        }
        &::before {
          content: '•';
          color: ${({ theme }) => theme.colorPrimary};
          display: inline-block;
          width: 1em;
          margin-left: -1em;
        }
      }
    }
  }
`;

const BackgroundCircle = styled.img`
  display: none;
  @media (min-width: ${media.smup}) {
    z-index: 10;
    display: block;
    position: absolute;
    left: ${props => props.left};
    top: ${props => props.top};
    transform: translate(-50%, -50%);
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Interiors.js